import 'es6-promise/auto';

import 'picturefill';

import 'focus-visible';

import objectFitImages from 'object-fit-images';

objectFitImages();

import svg4everybody from 'svg4everybody';

svg4everybody();

import elementClosest from 'element-closest';

elementClosest(window);
